/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewshowqr3Inputs */

const en_ticketpreviewshowqr3 = /** @type {(inputs: Ticketpreviewshowqr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show QR code`)
};

const de_ticketpreviewshowqr3 = /** @type {(inputs: Ticketpreviewshowqr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code zeigen`)
};

/**
* | output |
* | --- |
* | "Show QR code" |
*
* @param {Ticketpreviewshowqr3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewshowqr3 = /** @type {((inputs?: Ticketpreviewshowqr3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewshowqr3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewshowqr3(inputs)
	return de_ticketpreviewshowqr3(inputs)
});
export { ticketpreviewshowqr3 as "ticketPreviewShowQr" }